import React from 'react';

type SVGProps = {
	color?: string;
};

const SortIcon = ({ color }: SVGProps) => {
	return (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<g clip-path='url(#clip0_1204_11226)'>
				<path
					fill-rule='evenodd'
					clip-rule='evenodd'
					d='M11.9998 2.70625V14.4991C11.9998 14.7753 11.7759 14.9991 11.4998 14.9991C11.2236 14.9991 10.9998 14.7753 10.9998 14.4991V2.70625L7.85331 5.8527C7.65805 6.04796 7.34146 6.04796 7.1462 5.8527C6.95094 5.65744 6.95094 5.34085 7.1462 5.14559L11.1462 1.14559C11.3415 0.95033 11.658 0.95033 11.8533 1.14559L15.8533 5.14559C16.0486 5.34085 16.0486 5.65744 15.8533 5.8527C15.658 6.04796 15.3415 6.04796 15.1462 5.8527L11.9998 2.70625ZM4.99976 1.49915C4.99976 1.223 4.7759 0.999146 4.49976 0.999146C4.22361 0.999146 3.99976 1.223 3.99976 1.49915V13.292L0.85331 10.1456C0.658048 9.95033 0.341465 9.95033 0.146202 10.1456C-0.0490597 10.3409 -0.0490597 10.6574 0.146202 10.8527L4.1462 14.8527C4.34146 15.048 4.65805 15.048 4.85331 14.8527L8.85331 10.8527C9.04857 10.6574 9.04857 10.3409 8.85331 10.1456C8.65805 9.95033 8.34146 9.95033 8.1462 10.1456L4.99976 13.292V1.49915Z'
					fill='#05386B'
				/>
			</g>
			<defs>
				<clipPath id='clip0_1204_11226'>
					<rect
						width='16'
						height='16'
						fill='white'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default SortIcon;
